<template>
  <div tft-university-showdown-home>
    <HomeHeader />
    <OfficialLeague :officialLeagueData="officialLeagueData">
      <template #detail>
        <TftUniversityShowdownSchedule :apply-date="applyDate" :play-date="playDate" />
      </template>
      <template #gameInfo>
        <TftUniversityShowdownLeaderboard />
      </template>
    </OfficialLeague>
    <client-only><MyInfo /></client-only>
  </div>
</template>

<script>
import gtag from '@shared/mixins/gtag';
import OfficialLeague from '@/views/components/gameHome/OfficialLeague.vue';
import HomeHeader from '@/views/components/gameHome/HomeHeader.vue';
import MyInfo from '@/views/components/gameHome/MyInfo.vue';
import officialLeagueData from '@/data/official-league/officialLeagueData';
import TftUniversityShowdownSchedule from '@/views/components/gameHome/tft/gameInfo/TftUniversityShowdownSchedule.vue';
import TftUniversityShowdownLeaderboard from '@/views/components/gameHome/tft/gameInfo/TftUniversityShowdownLeaderboard.vue';
import meta from '@/data/meta';

export default {
  name: 'tftUniversityShowdownHome',
  mixins: [gtag],
  components: { TftUniversityShowdownLeaderboard, TftUniversityShowdownSchedule, MyInfo, HomeHeader, OfficialLeague },
  data() {
    return {
      applyDate: [
        { week: '예선 1차', date: '10월 19일 (월) ~ 11월 2일 (월)' },
        { week: '예선 2차', date: '10월 19일 (월) ~ 11월 2일 (월)' },
      ],
      playDate: [
        { week: '예선 1차', date: '11월 7일 (토)' },
        { week: '예선 2차', date: '11월 8일 (일)' },
        { week: '본선', date: '11월 14일 (토)' },
        { week: '결승', date: '11월 22일 (일)' },
      ],
    };
  },
  computed: {
    officialLeagueData() {
      return officialLeagueData[this.$route.params.id];
    },
  },
  methods: {
    toInit() {
      setTimeout(() => {
        const target = document.querySelector('.league');
        this.$scroll.scrollMove(target.offsetTop + (this.matchedMediaDevice === 'M' ? 450 : 700), 1000);
      }, 200);
    },
  },
  mounted() {
    if (this.$route.query.page && this.$route.query.page === 'arena') this.toInit();
  },
  metaInfo() {
    return meta[this.$route.params.id][this.$route.name];
  },
};
</script>

<style lang="less">
@import '~@/less/proj.less';

[tft-university-showdown-home] {
  [official-league] { background:
      linear-gradient(180deg, fade(@showdown-navy-deep, 0%) 30%, @showdown-navy-deep 98%) no-repeat 50% 0 / 100% ~"max(1152px, 72vw)",
      radial-gradient(ellipse 50% 28% at 50% 0%, fade(@showdown-gold, 25%), transparent 70%),
      /* webpackIgnore: true */ url('/img/pages/tftUniversityShowdown/bg_clouds.jpg') no-repeat 50% 0 / ~"max(100%, 1600px)" auto,
      @showdown-navy-deep;
    &:before { .cnt; .abs; .lt(0, 0); .wh(100%); .z(-1); .events-none;
      background: repeating-conic-gradient(from 160deg at 50% -8%, fade(@showdown-gold, 9%) 0deg 2deg, transparent 2deg 7deg);
      mask-image: radial-gradient(ellipse 75% 55% at 50% 0%, black 0%, fade(black, 35%) 55%, transparent 100%);
      .o(.55);
    }
    &:after { .cnt; .abs; .lt(0, 0); .wh(100%); .z(-1); .events-none; .o(.5);
      background:
        radial-gradient(circle, @showdown-gold-light 1px, transparent 1.5px) 0 0 / 137px 151px,
        radial-gradient(circle, @showdown-cream 1px, transparent 1.5px) 61px 83px / 211px 197px,
        radial-gradient(circle, fade(@showdown-gold, 70%) 1.5px, transparent 2px) 29px 140px / 283px 263px,
        radial-gradient(ellipse 120% 70% at 50% 100%, transparent 55%, fade(@showdown-navy-deep, 80%) 100%);
    }
    .slider-holder { .pb(0);
      .card-list-holder {
        .tab { .hide;}
      }
    }
  }
  @media (@tl-up) {
    .btn-ask { .w(140) !important;}
  }
  @media (@ds-up) {
    [official-league] {
      .slider-holder {
        .arrow-wrap { .hide; }
      }
    }
  }
}
</style>
